import DocumentPreview from "../components/ui/enterprise1/DocumentPreview";
import document1 from "../assests/HPE/enterpriseone/ent-a/webp/zip-documents-1.webp";
import document2 from "../assests/HPE/enterpriseone/ent-a/webp/zip-documents-2.webp";
import document3 from "../assests/HPE/enterpriseone/ent-a/webp/zip-documents-3.webp";
import downloadIcon from "../assests/HPE/enterpriseone/smb-a/download.svg";
import CardHeader from "../components/ui/enterprise1/CardHeader";
import EnterpriseHeader from "../components/ui/enterprise1/EnterpriseHeader";
import astraZenecapdf from "../assests/HPE/enterpriseone/ent-a/pdf/AstraZeneca Customer Story.pdf";
import gigaOmpdf from "../assests/HPE/enterpriseone/ent-a/pdf/GigaOm Radar.pdf";
import idcpdf from "../assests/HPE/enterpriseone/ent-a/pdf/IDC Spotlight.pdf";
import zipFile from "../assests/HPE/enterpriseone/ent-a/hybridCloud.zip";
import Layout from "../components/layout/Layout";

const ThankyouEnterprise = () => {
  const docs = [
    {
      img: document2,
      title: "GigaOm Radar",
      pages: "52 pages · PDF",
      file: gigaOmpdf,
    },
    {
      img: document3,
      title: "AstraZeneca Customer Story",
      pages: "4 pages · PDF",
      file: astraZenecapdf,
    },
    {
      img: document1,
      title: "IDC Spotlight",
      pages: "8 pages · PDF",
      file: idcpdf,
    },
  ];

  return (
    <Layout title="HPE Hybrid Cloud" variant="enterprise">
      <div className="w-full min-h-screen bg-navy-blue-01">
        {/* HEADER */}
        <div className="flex flex-col items-center text-center gap-4 mb-10 md:mb-16 max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto">
          <CardHeader
            title="Your resource pack is ready"
            description="Click below to download each document. If downloads do not start
          automatically, check your email."
          />
        </div>

        {/* MAIN SECTION */}
        <div className="flex flex-col md:flex-row items-start justify-between gap-10 md:gap-12 2xl:gap-[96px] w-full max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto">
          {/* LEFT */}
          <div className="relative w-full max-w-[320px] sm:max-w-[384px] mx-auto flex flex-col gap-4">
            <DocumentPreview documents={docs} />
            <a href={zipFile} download>
              <button className="top-[196%] w-full p-3 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 text-white font-medium hover:opacity-90 transition text-[14px] leading-[22px]">
                Download all
              </button>
            </a>
          </div>

          {/* RIGHT */}
          <div className="w-full md:flex-1 bg-navy-blue-02 rounded-[16px] p-4 md:p-8 flex flex-col gap-6">
            <p className="text-grey-01 text-[14px] leading-[22px] md:text-[16px] md:leading-[24px] font-google">
              You can also download files individually
            </p>

            {/* LIST */}
            <div className="flex flex-col">
              {docs.map((doc, i) => (
                <div key={i}>
                  {/* ITEM */}
                  <div className="flex items-center justify-between py-5">
                    {/* LEFT CONTENT */}
                    <div className="flex items-center gap-3">
                      <div className="w-[42px] h-[42px] flex items-center justify-center rounded-md bg-navy-blue-04">
                        <img
                          src={doc.img}
                          alt=""
                          className="w-full h-full object-cover rounded-sm"
                        />
                      </div>
                      <div>
                        <p className="text-grey-01 font-medium text-[14px] leading-[20px] md:text-[16px] md:leading-[22px] font-google">
                          {doc.title}
                        </p>
                        <p className="text-grey-03 text-[10px] leading-[18px] md:text-[12px] md:leading-[20px] font-inter">
                          {doc.pages}
                        </p>
                      </div>
                    </div>

                    {/* DOWNLOAD ICON */}
                    <a
                      href={doc.file}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={downloadIcon}
                        alt=""
                        className=" cursor-pointer"
                      />
                    </a>
                  </div>

                  {/* DIVIDER */}
                  {i !== docs.length - 1 && (
                    <div className="w-full h-[1px] border-white/10 border-dashed border-t" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default ThankyouEnterprise;
